/**
 * Updates the body element with language-specific classes for font family switching
 * @param {string} languageCode - The language code (e.g., 'en', 'ja')
 */
export const updateBodyLanguageClass = (languageCode) => {
  if (typeof document === 'undefined') return;

  const body = document.body;
  
  // Remove all existing language classes
  body.classList.remove('lang-en', 'lang-ja');
  body.removeAttribute('lang');
  body.removeAttribute('data-lang');
  
  // Add new language class and attributes
  if (languageCode) {
    body.classList.add(`lang-${languageCode}`);
    body.setAttribute('lang', languageCode);
    body.setAttribute('data-lang', languageCode);
  }
};
